<script setup>
  import { ref, computed, inject, onMounted } from 'vue'
  const props = defineProps({
    value: {
      type: [String, Number, Boolean],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowLineBreaks: {
      type: Boolean,
      default: true
    }
  });

  // Provided from SegmentedControl
  const buttonRefs = inject('buttonRefs');
  const activeValue = inject('activeValue');
  const isUserInput = inject('isUserInput');
  const controllerDisabled = inject('disabled');
  const changeHandler = inject('changeHandler');
  
  let buttonRef = ref(null);
  
  const isActive = computed(() => props.value === activeValue.value);

  function handleClick(e) {
    activeValue.value = props.value;
    isUserInput.value = true;
    changeHandler(e);
  }
  
  onMounted(() => {
    buttonRefs.value.push(buttonRef.value);
  })

</script>

<template>
  <li class="jwx-segmented-control__segment" role="menuitem">
    <button
      @click.prevent="handleClick"
      type="button"
      class="jwx-segmented-control__button"
      :value="value"
      :aria-pressed="isActive"
      :data-active="isActive"
      :data-allow-line-breaks="props.allowLineBreaks"
      :disabled="controllerDisabled || disabled"
      ref="buttonRef"
    >
      <slot></slot>
    </button>
  </li>
</template>